function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.636 4.91a1.636 1.636 0 0 1 3.273 0v14.18a1.636 1.636 0 1 1-3.273 0V4.91Zm19.091-.82a.818.818 0 1 1 1.637 0v15.82a.818.818 0 1 1-1.637 0V4.09Zm-5.454-.817c-.904 0-1.637.732-1.637 1.636v14.182a1.636 1.636 0 1 0 3.273 0V4.909c0-.904-.732-1.636-1.636-1.636Zm-8.728.818a.818.818 0 0 1 1.637 0v15.818a.818.818 0 1 1-1.637 0V4.091Zm4.091-.818a.818.818 0 0 0-.818.818v15.818a.818.818 0 1 0 1.636 0V4.091a.818.818 0 0 0-.818-.818Z",
  fill: "#2E3545"
});

function SvgBarcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.8888e7ce.svg";
export { ForwardRef as ReactComponent };